import * as models from '../../../../models';

export class AccountOwnerMapper {
  private static instance: AccountOwnerMapper = new AccountOwnerMapper();

  static Instance(): AccountOwnerMapper {
    return AccountOwnerMapper.instance;
  }

  accountOwnerDtoToAccountOwner(item: any): models.AccountOwner {
    const owner: models.AccountOwner = new models.AccountOwner();
    owner.id = item.id;
    owner.name = item.name;
    owner.email = item.email;
    return owner;
  }

  private constructor() {}
}
